import React from 'react';
import './HomeExtra.css'

const HomeExtra = () => {
    return (
        <div className='background'>
            <figure class="snip1543">
                <img src="https://eskipaper.com/images/2014-lamborghini-wallpaper-1.jpg" alt="sample108" />
                <figcaption>
                    <h3>Inverness McKenzie</h3>
                    <p>The only skills I have the patience to learn are those that have no real application in life.</p>
                </figcaption>
                <a href="#"></a>
            </figure>
            <figure class="snip1543 hover"><img src="https://cdn.wallpapersafari.com/42/29/H4psMD.jpg" alt="sample100" />
                <figcaption>
                    <h3>Alan Fresco</h3>
                    <p>The real fun of living wisely is that you get to be smug about it.</p>
                </figcaption>
                <a href="#"></a>
            </figure>
            <figure class="snip1543"><img src="https://images.hdqwalls.com/download/black-lamborghini-aventador-4k-2018-at-3840x2160.jpg" alt="sample101" />
                <figcaption>
                    <h3>Indigo Violet</h3>
                    <p>But Calvin is no kind and loving god! He's one of the old gods! He demands sacrifice! </p>
                </figcaption>
                <a href="#"></a>
            </figure>

        </div>
    );
};

export default HomeExtra;